import { create } from 'zustand';
import { platformNavMenuApi } from '@/api/platform-nav-menu';
import type { NavMenuNode } from '@/api/platform-nav-menu';

type LoadStatus = 'idle' | 'loading' | 'ready' | 'error';

interface PlatformNavState {
  loadStatus: LoadStatus;
  sidebarTree: NavMenuNode[] | null;
  routePermissionOverrides: Record<string, string | true> | null;
  loadPlatformNav: (force?: boolean) => Promise<void>;
  reset: () => void;
}

export const usePlatformNavStore = create<PlatformNavState>((set, get) => ({
  loadStatus: 'idle',
  sidebarTree: null,
  routePermissionOverrides: null,

  loadPlatformNav: async (force = false) => {
    if (!force && get().loadStatus === 'ready') return;
    set({ loadStatus: 'loading' });
    try {
      const [sidebarTree, routePermissionOverrides] = await Promise.all([
        platformNavMenuApi.getSidebar(),
        platformNavMenuApi.getRoutePermissions(),
      ]);
      set({
        sidebarTree,
        routePermissionOverrides,
        loadStatus: 'ready',
      });
    } catch {
      set({
        loadStatus: 'error',
        sidebarTree: null,
        routePermissionOverrides: null,
      });
    }
  },

  reset: () =>
    set({
      loadStatus: 'idle',
      sidebarTree: null,
      routePermissionOverrides: null,
    }),
}));
